import { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Settings, Plus } from "lucide-react";
import DashboardLayout from "@/components/DashboardLayout";
import BuyCreditsModal from "@/components/BuyCreditsModal";
import { useAuth } from "@/context/AuthContext";

const SettingsPage = () => {
  const { user } = useAuth();
  const [showBuyCredits, setShowBuyCredits] = useState(false);

  return (
    <DashboardLayout>
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-4xl font-bold mb-2" style={{ color: '#FFFFFF' }}>
            Account Settings
          </h1>
          <p className="text-lg" style={{ color: '#F5F7FA' }}>
            Manage your account preferences
          </p>
        </div>

        {/* User Info Card */}
        <Card className="glass-card mb-6">
          <CardHeader>
            <div className="flex items-center space-x-3 mb-2">
              <div 
                className="p-3 rounded-lg"
                style={{ backgroundColor: 'rgba(36, 84, 81, 0.15)' }}
              >
                <Settings className="h-6 w-6" style={{ color: '#245451' }} />
              </div>
              <div>
                <CardTitle style={{ color: '#245451' }}>Profile Information</CardTitle>
                <CardDescription style={{ color: '#64748B' }}>
                  Your account details
                </CardDescription>
              </div>
            </div>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <div>
                <p className="text-sm font-medium mb-1" style={{ color: '#64748B' }}>Name</p>
                <p className="text-base" style={{ color: '#245451' }}>{user?.name || 'N/A'}</p>
              </div>
              <div>
                <p className="text-sm font-medium mb-1" style={{ color: '#64748B' }}>Email</p>
                <p className="text-base" style={{ color: '#245451' }}>{user?.email || 'N/A'}</p>
              </div>
              <div>
                <p className="text-sm font-medium mb-1" style={{ color: '#64748B' }}>Firm Name</p>
                <p className="text-base" style={{ color: '#245451' }}>{user?.firm_name || 'Not specified'}</p>
              </div>
              <div className="pt-4 border-t" style={{ borderColor: 'rgba(132, 162, 172, 0.2)' }}>
                <p className="text-sm font-medium mb-2" style={{ color: '#64748B' }}>Credit Balance</p>
                <div className="flex items-center justify-between">
                  <p className="text-3xl font-bold" style={{ color: '#C49603' }}>{user?.credit_balance || 0} Credits</p>
                  <Button
                    onClick={() => setShowBuyCredits(true)}
                    size="lg"
                    className="px-6 h-12 text-base font-semibold"
                    style={{ backgroundColor: '#C49603', color: '#FFFFFF' }}
                  >
                    <Plus className="mr-2 h-5 w-5" />
                    Add Credits
                  </Button>
                </div>
                <p className="text-sm mt-2" style={{ color: '#84a2ac' }}>1 Credit = 1 Complete Medical Summary</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
      <BuyCreditsModal open={showBuyCredits} onClose={() => setShowBuyCredits(false)} />
    </DashboardLayout>
  );
};

export default SettingsPage;